import React, { useContext, useEffect, useState } from 'react';
import {
  useWeavy,
  WyChat,
  WyNotificationToasts,
  Weavy,
  WyNotifications,
} from '@weavy/uikit-react';
import { getOddsWeavyTokenApi } from '../../../apis';
import { AppContext } from '../../../appContext';
import NoChat from '../../../lottiefiles/nochat.json';
import Placeholder from '../../placeholder';

function WeavyNotification() {
  const { userDetails } = useContext(AppContext);
  // check safari version
  const [browserInfo, setBrowserInfo] = useState('');
  const [isChatAllowed, setIsChatAllowed] = useState(false);
  const [weavyError, setWeavyError] = useState(false);

  useEffect(() => {
    const getBrowserInfo = () => {
      const userAgent = navigator.userAgent;
      let browserDetails = 'Browser not detected';
      let allowChat = false;

      if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
        // Extract Safari version
        const safariVersionMatch = userAgent.match(/Version\/(\d+\.\d+)/);
        const safariVersion = safariVersionMatch
          ? parseFloat(safariVersionMatch[1])
          : 0;

        if (safariVersion >= 17) {
          browserDetails = `Safari version: ${safariVersion}`;
          allowChat = true;
        } else {
          browserDetails = `Safari version: ${safariVersion} (Chat not allowed for versions below 17)`;
          allowChat = false;
        }
      } else if (userAgent.includes('Chrome')) {
        browserDetails = 'You\'re using Chrome, chat is allowed.';
        allowChat = true;
      } else {
        browserDetails = 'You\'re using another browser, chat is allowed.';
        allowChat = true;
      }

      setBrowserInfo(browserDetails);
      setIsChatAllowed(allowChat);
    };

    getBrowserInfo();
     const userdataDetails = {
          userId: userDetails?.DoctorProfile?._id,
          username: `Dr.${userDetails?.DoctorProfile?.DoctorName}`,
        };
    getWeavyToken(userdataDetails)
  }, []);
 const getWeavyToken = async (user) => {
       try {
        //  const res = await getOddsWeavyTokenApi(user);
        //  if (res.status === 200 || res.status === 201) {
        //    return res.data.token;
        //  }
       } catch (err) {
         console.error('Error:', err);
         setWeavyError(true)
       }
     };
  console.log(browserInfo);
if (weavyError) {
    return (
     <div className="min-h-[40vh] w-full flex justify-center items-center ">
           <Placeholder
          animationData={NoChat}
          height={'160px'}
         title="Service Unavailable"
          message="Our chat service is temporarily down. Please try again later."
           />
        </div>
    );
  }
  return (
    <>
      {isChatAllowed ? (
        <WyNotifications></WyNotifications>
      ) : (
        <div className="min-h-[40vh] w-full flex justify-center items-center flex-col p-4">
          <Placeholder
          animationData={NoChat}
          height={'160px'}
          title='Feature Not Supported'
          message='This feature is available on Safari version 17 or higher. Please update your browser or use a compatible device.'
          />
          
        </div>
      )}
    </>
  );
}

export default WeavyNotification;
